























































import { BButton, BPopover } from "bootstrap-vue";
import useCampaigns from "@/views/modules/engage/useCampaigns";
import { ref } from "@vue/composition-api";

export default {
    components: {
        BButton,
        BPopover,
    },
    setup() {
        const { fetchLimit, currentLimit, isLoadingLimits, ratesData } = useCampaigns();
        const limitsHasBeenLoaded = ref(false);
        const popoverShow = ref(false);
        const onPopoverClose = () => {
            popoverShow.value = false;
        };

        fetchLimit().then(() => {
            limitsHasBeenLoaded.value = true;
        });

        return {
            currentLimit,
            isLoadingLimits,
            popoverShow,
            ratesData,
            limitsHasBeenLoaded,
            onPopoverClose,
        };
    },
};
